import Service from '@/utils/request'

// const service = new Service('http://60.29.39.171:8090/java', 3000, false)
const service = new Service(process.env.VUE_APP_BASE_URL2, 3000, false);
const request = service.request();

export function getUserInfoByToken(query) {
  return request({
    url: '/zcdx/matterApply/getUserInfoByToken',
    method: 'get',
    params: query
  })
} 